const mckinleyForm = {
  title: "MP+ Year-End Questionnaires",
  description:
    "The following questions and checklists will help you prepare and upload the necessary documents for us to complete year-end work on your behalf, making the process for preparing and lodging your returns more efficient for all, whether it be personal, business, rental property, or a combination. \n\nPlease commence the questionnaire, input your information so we can ensure our records are up to date, answer the questions relevant to you, and upload documentation as prompted through the process.\n\nDeclaration:\nBy completing this questionnaire, I hereby instruct you to prepare my Taxation Return(s) for the financial year ended 30 June 2025. I undertake to supply all information necessary to carry out such services, and will be responsible for the accuracy and completeness of such information.\n\nYou are hereby authorised to communicate with my bankers, solicitors, finance companies and all government agencies such as the ATO to obtain such information as you require to enable you to carry out the above assignment.\n\n I acknowledge and agree to McKinley Plowman’s standard Terms of Business, a copy of which I hold or can be obtained by contacting clientcare@mckinleyplowman.com.au.",
  completedHtml:
    "<h3>Thank you for completing our year-end tax questionnaire. We appreciate the time taken to do so as it allows us to efficiently complete your tax work and ensure you remain compliant with ATO requirements. We will be in touch with any further queries in due course. </h3>",
  pages: [
    {
      name: "details",
      elements: [
        {
          type: "dropdown",
          name: "title",
          title: "Title",
          isRequired: true,
          private: true,
          choices: ["DR", "MR", "MRS", "MISS", "MS"],
        },
        {
          type: "text",
          name: "firstName",
          startWithNewLine: false,
          title: "First Name",
          isRequired: true,
          maxLength: 255,
        },
        {
          type: "text",
          name: "middleName",
          startWithNewLine: false,
          title: "Middle Name",
          maxLength: 255,
        },
        {
          type: "text",
          name: "lastName",
          title: "Last Name",
          isRequired: true,
          maxLength: 255,
        },
        {
          type: "text",
          name: "email",
          title: "Email",
          isRequired: true,
          inputType: "email",
        },
        {
          type: "text",
          name: "question15",
          startWithNewLine: false,
          title: "Mobile",
          isRequired: true,
        },
        {
          type: "text",
          name: "dob",
          title: "Date of Birth",
          isRequired: true,
          inputType: "date",
          maxValueExpression: "today()",
        },
        {
          type: "text",
          name: "question4",
          startWithNewLine: false,
          title: "Place of birth",
          isRequired: true,
          maxLength: 255,
        },
        {
          type: "text",
          name: "tfn",
          title: "TFN",
          isRequired: true,
          private: true,
          tfn: true,
        },
        {
          type: "text",
          name: "question5",
          startWithNewLine: false,
          title: "Occupation",
          isRequired: true,
        },
        {
          type: "paneldynamic",
          name: "question36",
          title: "Did you have a spouse during the financial year?",
          templateElements: [
            {
              type: "html",
              name: "question6",
              html: "<H4>Spouse Details</H4>",
            },
            {
              type: "dropdown",
              name: "spouseSalutation",
              title: "Title",
              isRequired: true,
              choices: ["DR", "MR", "MRS", "MISS", "MS"],
            },
            {
              type: "text",
              name: "spouseFirstName",
              title: "Spouse First Name",
              isRequired: true,
              maxLength: 255,
            },
            {
              type: "text",
              name: "spouseLastName",
              startWithNewLine: false,
              title: "Last Name",
              isRequired: true,
              maxLength: 255,
            },
            {
              type: "text",
              name: "spouseEmail",
              title: "Spouse Email",
              isRequired: true,
              inputType: "email",
            },
            {
              type: "text",
              name: "question8",
              title: "Taxable Income ($)",
              isRequired: true,
              inputType: "number",
              min: 0,
            },
            {
              type: "html",
              name: "question11",
              html: "<b>Period that you had a spouse during the year</b>",
            },
            {
              type: "text",
              name: "startSpouse",
              title: "Start",
              requiredIf: "{panel.spouseAllYear} <> ['Yes']",
              inputType: "date",
            },
            {
              type: "text",
              name: "question12",
              startWithNewLine: false,
              title: "End",
              requiredIf: "{panel.spouseAllYear} <> ['Yes']",
              inputType: "date",
            },
            {
              type: "checkbox",
              name: "spouseAllYear",
              startWithNewLine: false,
              title: "All year?",
              choices: ["Yes"],
            },
          ],
          maxPanelCount: 1,
        },
        {
          type: "paneldynamic",
          name: "question18",
          title: "Add any dependents",
          templateElements: [
            {
              type: "text",
              name: "childName",
              title: "Name",
              isRequired: true,
            },
            {
              type: "text",
              name: "childDOB",
              startWithNewLine: false,
              title: "Date of Birth",
              isRequired: true,
              inputType: "date",
              maxValueExpression: "today()",
            },
            {
              type: "text",
              name: "question7",
              startWithNewLine: false,
              title: "Income ($)",
              inputType: "number",
              min: 0,
              step: 0.01,
            },
          ],
          maxPanelCount: 5,
        },
        {
          name: "panel2",
          type: "panel",
          title: "EFT Details",
          elements: [
            {
              name: "question9",
              type: "text",
              title: "Account Name",
            },
            {
              name: "bsbNumber",
              type: "text",
              title: "BSB Number",
              validators: [
                {
                  text: "Please enter in xxx-xxx or xxxyyy format",
                  type: "regex",
                  regex: "^(\\d{6}|\\d{3}-{1}\\d{3})$",
                },
              ],
            },
            {
              name: "accountNumber",
              type: "text",
              title: "Account Number",
              inputType: "number",
            },
          ],
        },
      ],
    },
    {
      name: "addresses",
      title: "Addresses",
      elements: [
        {
          type: "panel",
          name: "Physical Address",
          title: "Physical Address",
          isRequired: true,
          elements: [
            {
              type: "text",
              name: "question25",
              title: "Street Address - Not PO Box",
              isRequired: true,
            },
            {
              type: "text",
              name: "question14",
              title: "Town / City",
              isRequired: true,
            },
            {
              type: "text",
              name: "question26",
              title: "State / Region",
              isRequired: true,
            },
            {
              type: "text",
              name: "question16",
              title: "Post Code",
              isRequired: true,
            },
            {
              type: "text",
              name: "question17",
              title: "Country",
              isRequired: true,
            },
            {
              type: "text",
              name: "question19",
              title: "Fax",
            },
            {
              type: "text",
              name: "question27",
              title: "Home Phone",
            },
          ],
        },
        {
          type: "boolean",
          name: "postal",
          title: "Is Postal Address same as Physical Address?",
          defaultValue: "true",
        },
        {
          type: "panel",
          name: "panelPostal",
          visibleIf: "{postal} = false",
          title: "Postal Address",
          elements: [
            {
              type: "text",
              name: "question20",
              title: "Street Address or PO Box",
              isRequired: true,
            },
            {
              type: "text",
              name: "question21",
              title: "Town / City",
              isRequired: true,
            },
            {
              type: "text",
              name: "question22",
              title: "State / Region",
              isRequired: true,
            },
            {
              type: "text",
              name: "question23",
              title: "Post Code",
              isRequired: true,
            },
            {
              type: "text",
              name: "question24",
              title: "Country",
              isRequired: true,
            },
          ],
        },
      ],
    },
    {
      name: "servicesSelection",
      title: "Services Selection",
    },
    {
      name: "personalIncomeTaxPage",
      title: "Personal Income Tax Return - Year End Questionnaire",
      description:
        "To assist us in preparing your personal income tax return, please complete this questionnaire and upload documentation as prompted. Before you commence, please observe the following:\n\r\n•\tWith respect to your income, please keep in mind that the Australian Taxation Office (ATO) has the ability to check your return income against independent sources. In particular, this applies to PAYG Payment Summary income, interest received, dividends and asset sales.\n\r\n•\tFor deductions, keep in mind that self-assessment applies. In the event of an ATO audit, you will need to be able to substantiate the deductions claimed.\r\n\n•\tYou may upload multiple documents per question/item if required, each file must be less than 5MB in size.",
      elements: [
        {
          type: "radiogroup",
          name: "whenToLodgePersonalIncomeTax",
          title:
            "Please indicate when you require your tax return(s) to be completed and lodged",
          isRequired: true,
          choices: ["No hurry, just meet ATO lodgement deadline\t\t\t\t"],
          showOtherItem: true,
          otherText: "Other (please specify)",
        },
        {
          type: "text",
          name: "question30",
          visibleIf:
            "{whenToLodgePersonalIncomeTax} anyof ['For finance application', 'other']",
          title: "What date would you like your accounts to be lodged by?",
          requiredIf:
            "{whenToLodgePersonalIncomeTax} anyof ['For finance application', 'other']",
          inputType: "date",
          minValueExpression: "today()",
        },
        {
          type: "panel",
          name: "income",
          title: "Income",
          elements: [
            {
              type: "boolean",
              name: "recieveSalaryThisFY",
              title:
                "Did you receive any salary/wage income for the Financial Year? N.B. we can obtain these details from the ATO portal once available.",
            },
            {
              type: "file",
              allowMultiple: true,
              name: "salaryFile",
              visibleIf: "{recieveSalaryThisFY} = true",
              title: "Please upload your Payment Summary (5MB max)",
              storeDataAsText: false,
              waitForUpload: true,
              maxSize: 5000000,
              sourceType: "file-camera",
            },
            {
              type: "boolean",
              name: "directorsFee",
              title:
                "Did you receive directors’ fees, allowances or any other employment related income, not included in your salary/wage income above?",
            },
            {
              type: "file",
              allowMultiple: true,
              name: "directorsFeeFile",
              visibleIf: "{directorsFee} = true",
              title:
                "Please upload supporting documentation for directors’ fees, allowances or any other employment related income (5MB max)",
              storeDataAsText: false,
              waitForUpload: true,
              maxSize: 5000000,
              sourceType: "file-camera",
            },
            {
              type: "boolean",
              name: "etp",
              title:
                "Have you received any Employment Termination Payments (ETPs)?",
            },
            {
              type: "file",
              allowMultiple: true,
              name: "etpFile",
              visibleIf: "{etp} = true",
              title:
                "Please upload supporting documentation for Employment Termination Payments (ETPs) (5MB max)",
              storeDataAsText: false,
              waitForUpload: true,
              maxSize: 5000000,
              sourceType: "file-camera",
            },
            {
              type: "boolean",
              name: "govPensions",
              title:
                "Have you received any Australian Government pensions, allowance and payments?",
            },
            {
              type: "file",
              allowMultiple: true,
              name: "govPensionsFile",
              visibleIf: "{govPensions} = true",
              title:
                "Please upload supporting documentation for Australian Government pensions, allowances and payments (5MB max)",
              storeDataAsText: false,
              waitForUpload: true,
              maxSize: 5000000,
              sourceType: "file-camera",
            },
            {
              type: "boolean",
              name: "superannuationIncome",
              title:
                "Have you received any Australian Superannuation Income Stream, Lump Sum Superannuation payments or income from Annuities?",
            },
            {
              type: "file",
              allowMultiple: true,
              name: "superannuationFile",
              visibleIf: "{superannuationIncome} = true",
              title:
                "Please upload Statement(s) for your Superannuation payments (5MB max)",
              requiredIf: "{superannuationIncome} = true",
              storeDataAsText: false,
              waitForUpload: true,
              maxSize: 5000000,
              sourceType: "file-camera",
            },
            {
              type: "boolean",
              name: "bankInterest",
              title: "Did you receive any interest from Bank accounts?",
            },
            {
              type: "file",
              allowMultiple: true,
              name: "bankInterestFile",
              visibleIf: "{bankInterest} = true",
              title:
                "Please upload your Bank Statement(s) and/or an interest summary report from your bank (5MB max)",
              requiredIf: "{bankInterest} = true",
              storeDataAsText: false,
              waitForUpload: true,
              maxSize: 5000000,
              sourceType: "file-camera",
            },
            {
              type: "boolean",
              name: "dividends",
              title:
                "Did you receive any dividends / distributions from investments?",
            },
            {
              type: "file",
              allowMultiple: true,
              name: "dividendsFile",
              visibleIf: "{dividends} = true",
              title:
                "Please upload your Statement(s) for dividends/distributions (5MB max)",
              requiredIf: "{dividends} = true",
              storeDataAsText: false,
              waitForUpload: true,
              maxSize: 5000000,
              sourceType: "file-camera",
            },
            {
              type: "boolean",
              name: "employeeShareScheme",
              title:
                "Did you participate in an employee share scheme during the financial year? If so, please provide paperwork.",
            },
            {
              type: "file",
              allowMultiple: true,
              name: "employeeShareSchemeFile",
              visibleIf: "{employeeShareScheme} = true",
              title:
                "Please upload supporting documentation for the employee share scheme (5MB max)",
              requiredIf: "{employeeShareScheme} = true",
              storeDataAsText: false,
              waitForUpload: true,
              maxSize: 5000000,
              sourceType: "file-camera",
            },
            {
              type: "boolean",
              name: "distributionIncomeLoss",
              title:
                "Have you received, or are you entitled to receive, a distribution of income / loss from a partnership, trust, managed fund or forestry investment scheme?",
            },
            {
              type: "file",
              allowMultiple: true,
              name: "distributionIncomeLossFile",
              visibleIf: "{distributionIncomeLoss} = true",
              title:
                "Please upload supporting documentation for the distribution of income/loss, including any annual tax statements (5MB max)",
              requiredIf: "{distributionIncomeLoss} = true",
              storeDataAsText: false,
              waitForUpload: true,
              maxSize: 5000000,
              sourceType: "file-camera",
            },
            {
              type: "boolean",
              name: "investmentTransactions",
              title:
                "Did you acquire or dispose of any investments, which may include real estate, shares, collectables, listed & unlisted securities, crypto-currencies etc.? [Note - Buy, sell contracts and settlement statements will be required].",
            },
            {
              type: "file",
              allowMultiple: true,
              name: "investmentTransactionsFile",
              visibleIf: "{investmentTransactions} = true",
              title:
                "Please upload supporting documentation for your investment transactions (e.g. buy-sell contracts, settlement statements) (5MB max)",
              requiredIf: "{investmentTransactions} = true",
              storeDataAsText: false,
              waitForUpload: true,
              maxSize: 5000000,
              sourceType: "file-camera",
            },
            {
              type: "boolean",
              name: "sellAssets",
              title:
                "Did you sell any assets during the year that may attract Capital Gains Tax (CGT)? If so, please provide full details so we can determine whether CGT may apply to the transaction.",
            },
            {
              type: "comment",
              name: "sellAssetsDetails",
              visibleIf: "{sellAssets} = true",
              title: "Please provide full details regarding the asset sale.",
              requiredIf: "{sellAssets} = true",
            },
            {
              type: "file",
              allowMultiple: true,
              name: "sellAssetsFile",
              visibleIf: "{sellAssets} = true",
              title:
                "Please upload supporting documentation for the asset sale (e.g. sale contract) (5MB max)",
              isRequired: true,
              requiredIf: "{sellAssets} = true",
              storeDataAsText: false,
              waitForUpload: true,
              maxSize: 5000000,
              sourceType: "file-camera",
            },
            {
              type: "boolean",
              name: "carryOnBusiness",
              title:
                "Did you carry on a business during the year under an ABN that is registered in your name?",
            },
            {
              type: "html",
              name: "businessQuestionnaire",
              visibleIf: "{carryOnBusiness} = true",
              html: "Please complete the Business Questionnaire at the end of the survey.",
            },
            {
              type: "boolean",
              name: "primaryProduction",
              title: "Do you run a primary production (i.e. farming) business?",
            },
            {
              type: "boolean",
              name: "incomeOutsideAustralia",
              title:
                "Did you receive any income from sources ‘Outside of Australia’, whether pensions, interest, dividends, rent, employment or other income?",
            },
            {
              type: "file",
              allowMultiple: true,
              name: "incomeOutsideAustraliaFile",
              visibleIf: "{incomeOutsideAustralia} = true",
              title:
                "Please upload supporting documentation for income received from outside of Australia (5MB max)",
              requiredIf: "{incomeOutsideAustralia} = true",
              storeDataAsText: false,
              waitForUpload: true,
              maxSize: 5000000,
              sourceType: "file-camera",
            },
            {
              type: "boolean",
              name: "cashedLifeInsurance",
              title:
                "Have you cashed in any life insurance policies during the financial year?",
            },
            {
              type: "file",
              allowMultiple: true,
              name: "cashedLifeInsuranceFile",
              visibleIf: "{cashedLifeInsurance} = true",
              title:
                "Please upload supporting documentation (e.g. beneficiary statement) (5MB max)",
              requiredIf: "{cashedLifeInsurance} = true",
              storeDataAsText: false,
              waitForUpload: true,
              maxSize: 5000000,
              sourceType: "file-camera",
            },
            {
              type: "boolean",
              name: "rentalIncome",
              title:
                "Have you received rental income or made your property available for rent? If yes, please complete our Rental Property Questionnaire for each property.",
            },
            {
              type: "html",
              name: "rentalQuestionnaire",
              visibleIf: "{rentalIncome} = true",
              html: "Please complete the Rental Property Questionnaire at the end of the survey.",
            },
            {
              type: "paneldynamic",
              name: "otherIncome",
              title:
                "Have you received any other income not covered in the previous questions?",
              templateElements: [
                {
                  type: "text",
                  name: "incomeDetails",
                  title: "Details",
                },
                {
                  type: "text",
                  name: "incomeAnnual",
                  title: "Income (annual)",
                },
                {
                  type: "file",
                  allowMultiple: true,
                  name: "incomeSupportingDoc",
                  title: "Upload supporting documentation (5MB max)",
                  storeDataAsText: false,
                  waitForUpload: true,
                  maxSize: 5000000,
                  sourceType: "file-camera",
                },
              ],
              templateTitle: "Other Income Entry",
              panelCount: 1,
              maxPanelCount: 10,
            },
          ],
        },
        {
          type: "panel",
          name: "deductions",
          title: "Deductions",
          elements: [
            {
              type: "boolean",
              name: "motorVehicleExpenses",
              title:
                "Have you incurred motor vehicle expenses whilst travelling in the course of your employment?",
            },
            {
              type: "file",
              allowMultiple: true,
              name: "motorVehicleExpensesFile",
              visibleIf: "{motorVehicleExpenses} = true",
              title:
                "Please upload logbook/records of expenses, or evidence of kilometres travelled (5MB max)",
              requiredIf: "{motorVehicleExpenses} = true",
              storeDataAsText: false,
              waitForUpload: true,
              maxSize: 5000000,
              sourceType: "file-camera",
            },
            {
              type: "boolean",
              name: "newMotorVehicle",
              title:
                "Have you purchased a new motor vehicle that you have used for travelling during the course of your employment?",
            },
            {
              type: "file",
              allowMultiple: true,
              name: "newMotorVehicleFile",
              visibleIf: "{newMotorVehicle} = true",
              title:
                "Please upload dealer invoice and loan contract (if financed) and logbook percentage (5MB max)",
              storeDataAsText: false,
              waitForUpload: true,
              maxSize: 5000000,
              sourceType: "file-camera",
            },
            {
              type: "paneldynamic",
              name: "travelExpenses",
              title:
                "Do you undertake travel in relation to your employment resulting in out-of-pocket expenses?",
              templateElements: [
                {
                  type: "text",
                  name: "travelExpenseDetails",
                  title:
                    "Details e.g. travel diaries, taxi, airfares, parking, train fares, tolls, accommodation, hire cars, meals (overnight only)",
                },
                {
                  type: "file",
                  allowMultiple: true,
                  name: "travelExpenseFile",
                  title: "Upload supporting documentation (5MB max)",
                  storeDataAsText: false,
                  waitForUpload: true,
                  maxSize: 5000000,
                  sourceType: "file-camera",
                },
              ],
              templateTitle: "Travel Expense Entry",
              panelCount: 1,
              maxPanelCount: 10,
            },
            {
              type: "paneldynamic",
              name: "protectiveClothingExpenses",
              title:
                "Have you incurred costs in relation to purchasing, cleaning and/or repairing protective clothing, uniforms, occupation specific clothing, compulsory or registered uniforms? (N.B. you cannot claim the cost of purchasing plain uniforms or clothes, such as black trousers, white shirts or stockings, even if your employer requires you to wear them.)",
              templateElements: [
                {
                  type: "text",
                  name: "clothingItem",
                  title: "Clothing Item",
                },
                {
                  type: "text",
                  name: "clothingCostDetail",
                  title: "Costs Incurred (Detail)",
                },
                {
                  type: "text",
                  name: "clothingAmount",
                  title: "Amount ($)",
                },
                {
                  type: "file",
                  allowMultiple: true,
                  name: "clothingSupportingDoc",
                  title: "Upload supporting documentation (5MB max)",
                  storeDataAsText: false,
                  waitForUpload: true,
                  maxSize: 5000000,
                  sourceType: "file-camera",
                },
              ],
              templateTitle: "Clothing Expense Entry",
              panelCount: 1,
              maxPanelCount: 10,
            },
            {
              type: "paneldynamic",
              name: "selfEducationExpenses",
              title:
                "Did you complete any self-education courses? Will this course help you obtain a formal qualification? Is it in direct connection with your current work activities? (If yes, you may claim expenses such as textbooks, stationery, student union fees, travel and depreciation on computer, home office furniture etc.)",
              templateElements: [
                {
                  type: "text",
                  name: "educationExpenseItem",
                  title: "Expense/item to be claimed",
                },
                {
                  type: "text",
                  name: "educationAmount",
                  title: "Amount ($)",
                },
                {
                  type: "file",
                  allowMultiple: true,
                  name: "educationFile",
                  title: "Upload supporting documentation (5MB max)",
                  storeDataAsText: false,
                  waitForUpload: true,
                  maxSize: 5000000,
                  sourceType: "file-camera",
                },
              ],
              templateTitle: "Self-Education Expense Entry",
              panelCount: 1,
              maxPanelCount: 10,
            },
            {
              type: "paneldynamic",
              name: "otherWorkExpenses",
              title:
                "Have you paid for other work-related expenses such as trade or business tools, journals and/or subscriptions, union fees, sun protection, home office expenses, telephone/mobile phone, internet, computer hardware/software purchases, seminars, stationery?",
              templateElements: [
                {
                  type: "text",
                  name: "otherExpenseItem",
                  title: "Expense/item to be claimed",
                },
                {
                  type: "text",
                  name: "otherAmount",
                  title: "Amount ($)",
                },
                {
                  type: "text",
                  name: "percentageUse",
                  title:
                    "Please advise your work use percentage on any amounts not 100% for business?",
                  inputType: "number",
                  min: 0,
                  max: 100,
                  step: 0.01,
                  suffix: "%",
                },
                {
                  type: "file",
                  allowMultiple: true,
                  name: "otherExpenseFile",
                  title: "Upload supporting documentation (5MB max)",
                  storeDataAsText: false,
                  waitForUpload: true,
                  maxSize: 5000000,
                  sourceType: "file-camera",
                },
              ],
              templateTitle: "Work-Related Expense Entry",
              panelCount: 1,
              maxPanelCount: 10,
            },
            {
              type: "boolean",
              name: "workFromHome",
              title:
                "Did you work from home during the Financial Year? If so, please provide a daily diary of hours worked and a copy of 1 electricity bill.",
            },
            {
              type: "file",
              allowMultiple: true,
              name: "workFromHomeDiary",
              visibleIf: "{workFromHome} = true",
              title: "Upload daily diary of hours worked (5MB max)",
              storeDataAsText: false,
              waitForUpload: true,
              maxSize: 5000000,
              sourceType: "file-camera",
            },
            {
              type: "file",
              allowMultiple: true,
              name: "workFromHomeElectricity",
              visibleIf: "{workFromHome} = true",
              title: "Upload electricity bill (5MB max)",
              storeDataAsText: false,
              waitForUpload: true,
              maxSize: 5000000,
              sourceType: "file-camera",
            },
            {
              type: "boolean",
              name: "dividendsInterestExpenses",
              title:
                "Have you incurred any expenses relating to dividends or interest income? (E.g. account keeping, management fees & interest charged on money borrowed to purchase shares and units.)",
            },
            {
              type: "file",
              allowMultiple: true,
              name: "dividendsInterestExpensesFile",
              visibleIf: "{dividendsInterestExpenses} = true",
              title: "Upload supporting documentation (5MB max)",
              storeDataAsText: false,
              waitForUpload: true,
              maxSize: 5000000,
              sourceType: "file-camera",
            },
            {
              type: "boolean",
              name: "deductibleGifts",
              title:
                "Have you made any deductible gifts/donations? (E.g. charities, school building funds? Please provide details. N.B. raffle tickets or GoFundMe payments are not considered a donation.)",
            },
            {
              type: "file",
              allowMultiple: true,
              name: "deductibleGiftsFile",
              visibleIf: "{deductibleGifts} = true",
              title: "Upload donation receipt(s) (5MB max)",
              storeDataAsText: false,
              waitForUpload: true,
              maxSize: 5000000,
              sourceType: "file-camera",
            },
            {
              type: "boolean",
              name: "taxReturnExpenses",
              title:
                "Have you had any expenses relating to preparing and lodging your previous year’s tax return? (e.g. Tax agent fees, advice from a registered agent or travel obtaining tax advice?)",
              description:
                "N.B. if McKinley Plowman prepared your tax return for the previous financial year, we can locate your receipts in our system (no need to upload anything here)",
            },
            {
              type: "file",
              allowMultiple: true,
              name: "taxReturnExpensesFile",
              visibleIf: "{taxReturnExpenses} = true",
              title:
                "Upload supporting documentation e.g. invoice from previous accountant (5MB max)",
              storeDataAsText: false,
              waitForUpload: true,
              maxSize: 5000000,
              sourceType: "file-camera",
            },
            {
              type: "boolean",
              name: "insurancePremiums",
              title:
                "Have you personally paid sickness, accident or income protection insurance premiums?",
            },
            {
              type: "file",
              allowMultiple: true,
              name: "insurancePremiumsFile",
              visibleIf: "{insurancePremiums} = true",
              title: "Upload supporting documentation (5MB max)",
              storeDataAsText: false,
              waitForUpload: true,
              maxSize: 5000000,
              sourceType: "file-camera",
            },
            {
              type: "boolean",
              name: "superContributions",
              title:
                "Have you made personal contributions to a complying superannuation fund for which you wish to claim a deduction?",
            },
            {
              type: "file",
              allowMultiple: true,
              name: "superContributionsFile",
              visibleIf: "{superContributions} = true",
              title:
                "Please upload Super Fund acknowledgement letter (5MB max)",
              storeDataAsText: false,
              waitForUpload: true,
              maxSize: 5000000,
              sourceType: "file-camera",
            },
            {
              type: "boolean",
              name: "overlookedItems",
              title:
                "Did you incur any out of pocket expenses on any of these often-overlooked items? Parking fees and tolls, batteries for calculators, borrowing costs for negative gearing, travel between work and studies, travel to investment seminars for investors, capital works deduction on income-producing buildings etc. If so, please provide details.",
            },
            {
              type: "file",
              allowMultiple: true,
              name: "overlookedItemsFile",
              visibleIf: "{overlookedItems} = true",
              title: "Upload supporting documentation (5MB max)",
              storeDataAsText: false,
              waitForUpload: true,
              maxSize: 5000000,
              sourceType: "file-camera",
            },
          ],
        },
        {
          type: "panel",
          name: "tax_offsets",
          title: "Tax Offsets",
          elements: [
            {
              type: "boolean",
              name: "private_health_fund",
              title:
                "Were you a member of a private health fund(s)? (Note: This information will be available online from mid-July)",
            },
            {
              type: "boolean",
              name: "spouse_super_contribution",
              title:
                "Have you contributed any superannuation on behalf of your spouse?",
            },
            {
              type: "file",
              allowMultiple: true,
              name: "spouse_super_file",
              visibleIf: "{spouse_super_contribution} = true",
              title:
                "Upload Supporting Documentation regarding super contributions",
              storeDataAsText: false,
              waitForUpload: true,
              maxSize: 5000000,
            },
            {
              type: "boolean",
              name: "remote_area_residence",
              title:
                "Is your normal residence in a remote or isolated area of Australia?",
            },
            {
              type: "boolean",
              name: "maintained_invalid_dependents",
              title:
                "Did you maintain any of the following:\n- A spouse who was an invalid or cared for an invalid?\n- You or your spouse’s parent who was an invalid or cared for an invalid?\n- You or your spouse’s invalid child, brother or sister aged 16 years or older?",
            },
            {
              type: "boolean",
              name: "medicare_levy_exemption",
              title:
                "If you are exempt from paying the Medicare Levy, please provide a copy of your Medicare exemption certificate.",
            },
            {
              type: "file",
              allowMultiple: true,
              name: "medicare_levy_file",
              visibleIf: "{medicare_levy_exemption} = true",
              title: "Upload Medicare levy exemption certificate",
              storeDataAsText: false,
              waitForUpload: true,
              maxSize: 5000000,
            },
            {
              type: "boolean",
              name: "student_loan_debt",
              title: "Do you have a HELP, SSL, TSL or SFSS debt?",
            },
            {
              type: "boolean",
              name: "child_support",
              title: "Did you pay or receive any child support?",
            },
            {
              type: "comment",
              name: "child_support_details",
              visibleIf: "{child_support} = true",
              title: "Please provide details of payments made/received",
            },
            {
              type: "boolean",
              name: "became_resident",
              title:
                "Did you become a resident (for tax purposes) of Australia during the Financial Year?",
            },
            {
              type: "text",
              name: "became_resident_date",
              visibleIf: "{became_resident} = true",
              title: "Please advise the date you became a resident",
              requiredIf: "{became_resident} = true",
              inputType: "date",
            },
            {
              type: "boolean",
              name: "ceased_residency",
              title:
                "Did you cease residency (for tax purposes) of Australia during the Financial Year?",
            },
            {
              type: "text",
              name: "ceased_residency_date",
              visibleIf: "{ceased_residency} = true",
              title: "Please advise the date you ceased residency",
              inputType: "date",
            },
          ],
        },
        {
          type: "panel",
          name: "personal_business_lending",
          title: "Personal / Business Lending",
          elements: [
            {
              type: "boolean",
              name: "has_loan_or_debt",
              title:
                "Do you have a home loan, investment property loan, or personal debt?",
            },
            {
              type: "dropdown",
              name: "last_loan_review",
              visibleIf: "{has_loan_or_debt} = true",
              title:
                "When did you last review your interest rate or loan structure?",
              choices: [
                "Within 12 months",
                "1–3 years ago",
                "More than 3 years ago",
                "Never",
              ],
            },
            {
              type: "boolean",
              name: "want_broker_loan_review",
              visibleIf: "{last_loan_review} = '1–3 years ago'",
              title:
                "Interest rates have changed significantly. Would you like one of our brokers to check if you could be saving on your current loans?",
            },
            {
              type: "boolean",
              name: "lend_analysis_interest",
              title:
                "Would you like to have an analysis of your existing borrowings or your lending position reviewed at no charge?",
            },
          ],
        },
        {
          type: "panel",
          name: "wealth_creation",
          title: "Wealth Creation",
          elements: [
            {
              type: "boolean",
              name: "have_financial_plan",
              title:
                "Do you have a financial plan in place and being implemented by a financial adviser, to help you achieve your lifestyle goals and objectives?",
            },
            {
              type: "boolean",
              name: "interested_in_wealth_creation",
              title:
                "Would you be keen to learn how you can create and grow your wealth?",
            },
            {
              type: "radiogroup",
              name: "correct_super_fund",
              title:
                "Do you have the right kind of superannuation fund and underlying investments to deliver the retirement outcome you want?",
              choices: ["Yes", "No", "Unsure"],
            },
            {
              type: "radiogroup",
              name: "correct_insurance_cover",
              title:
                "Do you have the right insurance cover in place to protect you and your family in the event of a premature death, diagnosis of a serious medical condition, or a disablement or injury preventing you from being able to work?",
              choices: ["Yes", "No", "Unsure"],
            },
            {
              type: "boolean",
              name: "pre_retiree_strategies",
              title:
                "Did you know that there are a range of strategies available to pre-retirees that can help to minimise tax, boost superannuation savings, and deliver significantly improved retirement outcomes?",
            },
            {
              type: "boolean",
              name: "want_wealth_consult",
              title:
                "Would you like to have an initial conversation with one of our financial planners to discuss any of the above?",
            },
          ],
        },
        {
          type: "panel",
          name: "wills_and_estate",
          title: "Wills & Estate",
          elements: [
            {
              type: "boolean",
              name: "have_current_will",
              title: "Do you have a current Will?",
            },
            {
              type: "boolean",
              name: "circumstances_changed",
              title:
                "Have your circumstances changed since you signed your last will (i.e. marriage, children, grandchildren, divorce)?",
            },
            {
              type: "comment",
              name: "circumstance_change_details",
              visibleIf: "{circumstances_changed} = true",
              title: "Please provide further details",
              requiredIf: "{circumstances_changed} = true",
            },
            {
              type: "boolean",
              name: "have_attorney",
              title:
                "Have you nominated an attorney to deal with your assets if you’re unable to?",
            },
            {
              type: "boolean",
              name: "have_guardian",
              title:
                "Have you nominated a guardian to help you (personally) if you’re unable to?",
            },
            {
              type: "boolean",
              name: "beneficiary_or_distribution",
              title:
                "Are you a beneficiary of, or have you received a distribution from, a deceased estate?",
            },
            {
              type: "boolean",
              name: "want_estate_consult",
              title:
                "Dealing with the death of a family member is stressful enough without having to worry about their estate affairs. Would you like a consult, at no charge, to discuss estate advice, tax, superannuation, life insurance, property, and administration of deceased estates?",
            },
          ],
        },
        {
          name: "otherPanels",
          type: "panel",
          title: "Other Areas",
          elements: [
            {
              type: "boolean",
              name: "worked_in_uk",
              title: "Have you worked in the UK?",
            },
            {
              type: "text",
              name: "worked_in_uk_years",
              visibleIf: "{worked_in_uk} = true",
              title: "For how many consecutive years did you work in the UK?",
              requiredIf: "{worked_in_uk} = true",
              inputType: "number",
            },
            {
              type: "comment",
              name: "anything_else",
              title:
                "Is there anything else we can help you with, or do you have any further comments?",
            },
          ],
        },
      ],
    },
    {
      name: "businessTaxReturn",
      visibleIf: "{carryOnBusiness} = true",
      title: "Business Year-End Questionnaire",
      elements: [
        {
          type: "paneldynamic",
          name: "business_tax_return",
          visibleIf: "{carryOnBusiness} = true",
          title: "Business Year-End Questionnaire",
          description:
            "Please complete one Business Year-End Questionnaire per business entity. Press “Add new” to begin.\n\nIf you have multiple entities, you can add additional questionnaires at the bottom of the page. \n",
          requiredIf: "{carryOnBusiness} = true",
          templateElements: [
            {
              type: "text",
              name: "entity_name",
              title: "Entity Name",
              isRequired: true,
            },
            {
              type: "text",
              name: "abn",
              title: "ABN",
              isRequired: true,
            },
            {
              type: "radiogroup",
              name: "accounting_software_used",
              title: "Accounting Software Used",
              showCommentArea: true,
              choices: [
                "Xero",
                "MYOB AccountRight Live",
                "MYOB Business Platform (formerly MYOB Essentials)",
                "Desktop MYOB / QuickBooks",
              ],
              showOtherItem: true,
            },
            {
              type: "html",
              name: "accounting_software_used1",
              visibleIf: "{panel.accounting_software_used} allof ['other']",
              title: "Accounting Software Used",
              html: "Upon completion of this survey, please contact McKinley Plowman to arrange access to your accounting system.",
            },
            {
              type: "panel",
              name: "bookkeeping_finalisation_checklist",
              title: "Bookkeeping Finalisation Checklist",
              elements: [
                {
                  type: "panel",
                  name: "item_1",
                  title:
                    "1. If you have received any adjusting/reconciling journals for the previous year end, please ensure they are entered before proceeding.",
                  isRequired: true,
                  elements: [
                    {
                      type: "radiogroup",
                      name: "item_1_status",
                      title: "Tick when complete or mark as N/A",
                      choices: ["Complete", "N/A"],
                    },
                  ],
                },
                {
                  type: "panel",
                  name: "item_2",
                  title:
                    "2. Ensure all bank accounts are reconciled to 30 June. For any irreconcilable items, please provide explanatory details.",
                  elements: [
                    {
                      type: "radiogroup",
                      name: "item_2_status",
                      title: "Tick when complete or mark as N/A",
                      isRequired: true,
                      choices: ["Complete", "N/A"],
                    },
                    {
                      type: "comment",
                      name: "item_2_details",
                      title: "Optional: Explanatory details",
                    },
                  ],
                },
                {
                  type: "panel",
                  name: "item_3",
                  title:
                    "3. Ensure all creditors and debtors are reconciled to 30 June. Reconciliation total should match balance sheet. Address any discrepancies.",
                  elements: [
                    {
                      type: "radiogroup",
                      name: "item_3_status",
                      title: "Tick when complete or mark as N/A",
                      isRequired: true,
                      choices: ["Complete", "N/A"],
                    },
                    {
                      type: "comment",
                      name: "item_3_details",
                      title: "Optional: Explanatory details",
                    },
                  ],
                },
                {
                  type: "panel",
                  name: "item_4",
                  title:
                    "4. Perform an annual GST reconciliation to 30 June (if possible). Address any discrepancies. Upload spreadsheet if available.",
                  elements: [
                    {
                      type: "radiogroup",
                      name: "item_4_status",
                      title: "Tick when complete or mark as N/A",
                      isRequired: true,
                      choices: ["Complete", "N/A"],
                    },
                    {
                      type: "comment",
                      name: "item_4_details",
                      title: "Optional: Explanatory details",
                    },
                    {
                      type: "file",
                      allowMultiple: true,
                      name: "item_4_file",
                      title: "Optional: Upload reconciliation spreadsheet",
                      storeDataAsText: false,
                      waitForUpload: true,
                      maxSize: 5000000,
                    },
                  ],
                },
                {
                  type: "panel",
                  name: "item_5",
                  title:
                    "5. Perform annual payroll reconciliation (if applicable). Ensure super was calculated correctly. Upload spreadsheet if available.",
                  elements: [
                    {
                      type: "radiogroup",
                      name: "item_5_status",
                      title: "Tick when complete or mark as N/A",
                      isRequired: true,
                      choices: ["Complete", "N/A"],
                    },
                    {
                      type: "comment",
                      name: "item_5_details",
                      title: "Optional: Explanatory details",
                    },
                    {
                      type: "file",
                      allowMultiple: true,
                      name: "item_5_file",
                      title: "Optional: Upload reconciliation spreadsheet",
                      storeDataAsText: false,
                      waitForUpload: true,
                      maxSize: 5000000,
                    },
                  ],
                },
                {
                  type: "panel",
                  name: "item_6",
                  title:
                    "6. Ensure Single Touch Payroll (STP) final lodgement is completed.",
                  elements: [
                    {
                      type: "radiogroup",
                      name: "item_6_status",
                      title: "Tick when complete or mark as N/A",
                      isRequired: true,
                      choices: ["Complete", "N/A"],
                    },
                  ],
                },
                {
                  type: "panel",
                  name: "item_7",
                  title:
                    "7. Reconcile ATO integrated client account or income tax account and reflect on balance sheet.",
                  elements: [
                    {
                      type: "radiogroup",
                      name: "item_7_status",
                      title: "Tick when complete or mark as N/A",
                      isRequired: true,
                      choices: ["Complete", "N/A"],
                    },
                  ],
                },
                {
                  type: "panel",
                  name: "item_8",
                  title:
                    "8. Review creditors and debtors over 90 days. Confirm recoverable or write off as bad debts.",
                  isRequired: true,
                  elements: [
                    {
                      type: "radiogroup",
                      name: "item_8_status",
                      title: "Tick when complete or mark as N/A",
                      choices: ["Complete", "N/A"],
                    },
                  ],
                },
                {
                  type: "panel",
                  name: "item_9",
                  title:
                    "9. Verify inventory or stock on hand as of 30 June, if applicable.",
                  isRequired: true,
                  elements: [
                    {
                      type: "radiogroup",
                      name: "item_9_status",
                      title: "Tick when complete or mark as N/A",
                      choices: ["Complete", "N/A"],
                    },
                  ],
                },
                {
                  type: "panel",
                  name: "item_10",
                  title:
                    "10. Verify value of work in progress at 30 June, if applicable. ",
                  isRequired: true,
                  elements: [
                    {
                      type: "radiogroup",
                      name: "item_10_status",
                      title: "Tick when complete or mark as N/A",
                      choices: ["Complete", "N/A"],
                    },
                  ],
                },
                {
                  type: "panel",
                  name: "item_11",
                  title:
                    "11. Ensure capital purchases have adequate descriptions in bookkeeping memos. Motor vehicles must include accurate dates and regos.",
                  elements: [
                    {
                      type: "radiogroup",
                      name: "item_11_status",
                      title: "Tick when complete or mark as N/A",
                      isRequired: true,
                      choices: ["Complete", "N/A"],
                    },
                  ],
                },
                {
                  type: "panel",
                  name: "item_12",
                  title:
                    "12. Ensure repair and maintenance expenses have clear memo descriptions of the nature of the repair.",
                  isRequired: true,
                  elements: [
                    {
                      type: "radiogroup",
                      name: "item_12_status",
                      title: "Tick when complete or mark as N/A",
                      choices: ["Complete", "N/A"],
                    },
                  ],
                },
                {
                  type: "panel",
                  name: "item_13",
                  title:
                    "13. For multiple business vehicles, include identifying info in memos.",
                  elements: [
                    {
                      type: "radiogroup",
                      name: "item_13_status",
                      title: "Tick when complete or mark as N/A",
                      isRequired: true,
                      choices: ["Complete", "N/A"],
                    },
                  ],
                },
                {
                  type: "panel",
                  name: "item_14",
                  title:
                    "14. For prepaid expenses (e.g. insurance, advertising, subscriptions), ensure the memo includes the date range.",
                  elements: [
                    {
                      type: "radiogroup",
                      name: "item_14_status",
                      title: "Tick when complete or mark as N/A",
                      isRequired: true,
                      choices: ["Complete", "N/A"],
                    },
                  ],
                },
                {
                  type: "file",
                  allowMultiple: true,
                  name: "copy_of_insurance_invoices",
                  title:
                    "For insurances, include a copy of insurance invoices and funding if applicable. (5MB max)",
                  storeDataAsText: false,
                  waitForUpload: true,
                  maxSize: 5000000,
                  sourceType: "file-camera",
                },
                {
                  type: "panel",
                  name: "item_15",
                  title:
                    "15. Ensure memo descriptions are adequate for entertainment or staff amenities expenses.",
                  elements: [
                    {
                      type: "radiogroup",
                      name: "item_15_status",
                      title: "Tick when complete or mark as N/A",
                      choices: ["Complete", "N/A"],
                    },
                  ],
                },
                {
                  type: "panel",
                  name: "item_16",
                  title:
                    "16. Lock your bookkeeping system at 30 June to prevent unintended changes.",
                  isRequired: true,
                  elements: [
                    {
                      type: "radiogroup",
                      name: "item_16_status",
                      title: "Tick when complete or mark as N/A",
                      choices: ["Complete", "N/A"],
                    },
                  ],
                },
              ],
            },
            {
              type: "html",
              name: "question10",
              html: "<b>Documents we will require from you.</b>\n\nPlease work though the checklist below, ensuring each item has been addressed.\n",
            },
            {
              type: "panel",
              name: "desktop_myob_checklist",
              title: "\n",
              elements: [
                {
                  type: "file",
                  allowMultiple: true,
                  name: "reconciled_data_file",
                  visibleIf:
                    "{accounting_software_used1} contains 'Desktop MYOB / QuickBooks'",
                  title: "Upload your reconciled data file",
                  storeDataAsText: false,
                  waitForUpload: true,
                  maxSize: 5000000,
                },
                {
                  type: "text",
                  name: "program_name_version",
                  visibleIf:
                    "{accounting_software_used1} contains 'Desktop MYOB / QuickBooks'",
                  title: "Program Name and Version Number",
                },
                {
                  type: "text",
                  name: "desktop_login",
                  visibleIf:
                    "{accounting_software_used1} contains 'Desktop MYOB / QuickBooks'",
                  title: "Login",
                },
                {
                  type: "text",
                  name: "desktop_password",
                  visibleIf:
                    "{accounting_software_used1} contains 'Desktop MYOB / QuickBooks'",
                  title: "Password",
                },
                {
                  type: "file",
                  allowMultiple: true,
                  name: "bank_statements_30_june",
                  title:
                    "Upload bank statements showing balance at 30 June for each reconciled bank account",
                  storeDataAsText: false,
                  waitForUpload: true,
                  maxSize: 5000000,
                },
                {
                  type: "file",
                  allowMultiple: true,
                  name: "investments_acquired",
                  title:
                    "Upload documentation for investments acquired during the year",
                  storeDataAsText: false,
                  waitForUpload: true,
                  maxSize: 5000000,
                },
                {
                  type: "file",
                  allowMultiple: true,
                  name: "investments_disposed",
                  title:
                    "Upload documentation for investments disposed of during the year",
                  storeDataAsText: false,
                  waitForUpload: true,
                  maxSize: 5000000,
                },
                {
                  type: "file",
                  allowMultiple: true,
                  name: "investment_income_docs",
                  title: "Upload dividend/interest/trust income documentation",
                  storeDataAsText: false,
                  waitForUpload: true,
                  maxSize: 5000000,
                },
                {
                  type: "file",
                  allowMultiple: true,
                  name: "capital_gains_contracts",
                  title:
                    "Upload contract and settlement statement for capital asset sales/purchases",
                  storeDataAsText: false,
                  waitForUpload: true,
                  maxSize: 5000000,
                },
                {
                  type: "file",
                  allowMultiple: true,
                  name: "capital_gains_income",
                  title:
                    "Upload documentation for capital gains income received",
                  storeDataAsText: false,
                  waitForUpload: true,
                  maxSize: 5000000,
                },
                {
                  type: "file",
                  allowMultiple: true,
                  name: "capital_gains_costs",
                  title:
                    "Upload documentation for costs related to capital gains",
                  storeDataAsText: false,
                  waitForUpload: true,
                  maxSize: 5000000,
                },
                {
                  type: "file",
                  allowMultiple: true,
                  name: "fixed_asset_purchases",
                  title:
                    "Upload tax invoices or documentation for major plant/equipment or fixed asset purchases",
                  storeDataAsText: false,
                  waitForUpload: true,
                  maxSize: 5000000,
                },
                {
                  type: "file",
                  allowMultiple: true,
                  name: "motor_vehicle_logbook",
                  title:
                    "Upload motor vehicle log book or business usage percentage documentation",
                  storeDataAsText: false,
                  waitForUpload: true,
                  maxSize: 5000000,
                },
                {
                  type: "file",
                  allowMultiple: true,
                  name: "vehicle_km_tracking",
                  title:
                    "Upload total km travelled or odometer readings from 1.4.24 to 31.3.25 for each vehicle",
                  storeDataAsText: false,
                  waitForUpload: true,
                  maxSize: 5000000,
                },
                {
                  type: "paneldynamic",
                  name: "loan_finance_details",
                  title:
                    "Loans and Finance – Provide details and upload loan documentation for each (where applicable)",
                  templateElements: [
                    {
                      type: "file",
                      allowMultiple: true,
                      name: "loan_docs",
                      title:
                        "Upload loan documents (hire purchase, mortgage, etc.)",
                      storeDataAsText: false,
                      waitForUpload: true,
                      maxSize: 5000000,
                    },
                    {
                      type: "text",
                      name: "loan_security",
                      title: "Details of security provided",
                    },
                    {
                      type: "text",
                      name: "loan_costs",
                      title:
                        "Borrowing costs incurred (e.g. establishment fees)",
                    },
                    {
                      type: "text",
                      name: "loan_purpose",
                      title: "Purpose of borrowing",
                    },
                  ],
                  templateTitle: "Loan {panelIndex}",
                  panelCount: 1,
                  minPanelCount: 1,
                },
                {
                  type: "file",
                  allowMultiple: true,
                  name: "bas_supporting_docs",
                  title:
                    "Upload supporting documentation used to prepare BAS (if MP+ does not prepare it)",
                  storeDataAsText: false,
                  waitForUpload: true,
                  maxSize: 5000000,
                },
                {
                  type: "file",
                  allowMultiple: true,
                  name: "payroll_reporting_docs",
                  title:
                    "Upload STP, Super Stream, Payroll Tax reports or login details (if applicable)",
                  storeDataAsText: false,
                  waitForUpload: true,
                  maxSize: 5000000,
                },
              ],
            },
            {
              type: "panel",
              name: "grant_mp_access",
              visibleIf:
                "{panel.accounting_software_used} anyof ['Xero', 'MYOB AccountRight Live', 'MYOB Business Platform (formerly MYOB Essentials)', 'Desktop MYOB / QuickBooks']",
              title: "Grant MP+ Access to Your Cloud Accounting Software",
              elements: [
                {
                  type: "html",
                  name: "grant_access_myob_essentials",
                  visibleIf:
                    "{panel.accounting_software_used} contains ['MYOB Business Platform (formerly MYOB Essentials)']",
                  html: '<div>\n  <h4 style="margin-left:20px;">MYOB Business Platform (formerly MYOB Essentials)</h4>\n\n  <p style="margin-left:40px;">1. Go to the Setup menu and choose User Access. The User Access window appears.</p>\n  <p style="margin-left:40px;">2. Click the Manage online access button.</p>\n  <p style="margin-left:40px;">3. If prompted, sign in using your MYOB account details (email address and password). The Manage online access page opens in your browser.</p>\n  <p style="margin-left:40px;">4. If we have previously been provided access to your software, please find the user in the list of online file users (<b>workflow</b>).</p>\n  <p style="margin-left:40px;">5. Click <b>Remove access</b>. This user is removed from the list.</p>\n  <p style="margin-left:40px;">6. Click <b>Invite new online administrator</b>. The invitation window appears.</p>\n\n  <p style="margin-left:40px;">7. Enter the user\'s details per below:</p>\n  <p style="margin-left:60px;">a. <b>First Name:</b> McKinley&nbsp;&nbsp;<b>Surname:</b> Plowman</p>\n  <p style="margin-left:60px;">b. <b>Email:</b> workflow@mckinleyplowman.com.au</p>\n\n  <p style="margin-left:40px;">8. Click <b>Invite</b>. The Manage online access page reappears with a confirmation message at the top. Two emails will be sent to McKinley Plowman: one advises that their online file user access is cancelled, the other invites them to become an online administrator.</p>\n</div>',
                },
                {
                  type: "html",
                  name: "grant_access_myob_account_right",
                  visibleIf:
                    "{panel.accounting_software_used} contains ['MYOB AccountRight Live']",
                  html: '<h4>MYOB AccountRight Live</h4>\n<div>\n  <p style="margin-left:40px;">1. Go to the Setup menu and choose User Access. The User Access window appears.</p>\n\n  <p style="margin-left:40px;">\n    2. If we have previously been provided access to your software, please find the user in the list of online file users (<b>workflow</b>), highlight the user and click on the rubbish bin icon on the right-hand side of the New Advisor button.\n  </p>\n\n  <p style="margin-left:40px;">3. Once removed, click <b>New Advisor</b>.</p>\n\n  <p style="margin-left:40px;">4. Ensure the top box is selected “The user will sign on with a my.MYOB account” (Recommended).</p>\n\n  <p style="margin-left:40px;">\n    5. Enter the user\'s details per below:\n  </p>\n  <p style="margin-left:60px;">a. Username: <b>Workflow</b></p>\n  <p style="margin-left:60px;">b. Email: <b>workflow@mckinleyplowman.com.au</b></p>\n\n  <p style="margin-left:40px;">\n    6. Select the box underneath the email address to “Invite user to be an online Administrator.”\n  </p>\n\n  <p style="margin-left:40px;">\n    7. Click on “Save and Invite User.” The Manage online access page reappears with a confirmation message at the top. Two emails will be sent to McKinley Plowman: one advises that their online file user access is cancelled, the other invites them to become an online administrator.\n  </p>\n</div>',
                },
                {
                  type: "html",
                  name: "grant_access_xero",
                  visibleIf:
                    "{panel.accounting_software_used} contains ['Xero']",
                  html: '<h4>Xero</h4>\n<div>\n  <p style="margin-left:40px;">1. Click on the business name in the top right-hand corner of the screen</p>\n  <p style="margin-left:40px;">2. Go to Settings</p>\n  <p style="margin-left:40px;">3. Click on Users</p>\n\n  <p style="margin-left:40px;">\n    4. If we have previously been provided access to your Xero software, please ensure we have the following access:\n  </p>\n  <p style="margin-left:60px;">- Advisor</p>\n  <p style="margin-left:60px;">- Reports</p>\n  <p style="margin-left:60px;">- Payroll Admin</p>\n  <p style="margin-left:60px;">- Manage Users</p>\n\n  <p style="margin-left:40px;">\n    5. If we have not been provided access previously – click “Invite User” in the top right-hand corner\n  </p>\n\n  <p style="margin-left:40px;">\n    6. Enter the user\'s details per below:\n  </p>\n  <p style="margin-left:60px;">a. First Name: McKinley Last Name: Plowman</p>\n  <p style="margin-left:60px;">b. Email: workflow@mckinleyplowman.com.au</p>\n  <p style="margin-left:60px;">c. Provide the same access as step 4</p>\n\n  <p style="margin-left:40px;">7. Click Send Invite.</p>\n</div>',
                },
              ],
            },
          ],
        },
      ],
    },
    {
      name: "rentalTaxPage",
      visibleIf: "{rentalIncome} = true",
      title: "Rental Tax Schedule",
      elements: [
        {
          type: "paneldynamic",
          name: "rental_property_tax_schedule",
          visibleIf: "{rentalIncome} = true",
          requiredIf: "{rentalIncome} = true",
          title: "Rental Property Tax Schedule",
          templateElements: [
            {
              type: "panel",
              name: "property_details",
              title: "Property Details",
              elements: [
                {
                  type: "text",
                  name: "property_number",
                  title: "No.",
                },
                {
                  type: "text",
                  name: "property_street",
                  title: "Street",
                },
                {
                  type: "text",
                  name: "property_suburb",
                  title: "Suburb",
                },
                {
                  type: "text",
                  name: "property_state",
                  title: "State",
                },
                {
                  type: "text",
                  name: "property_postcode",
                  title: "Postcode",
                },
                {
                  type: "text",
                  name: "weeks_rented",
                  title: "No. of weeks rented this year",
                },
                {
                  type: "text",
                  name: "purchase_date",
                  title: "Date property was purchased",
                  inputType: "date",
                },
                {
                  type: "text",
                  name: "purchase_price",
                  title: "Purchase price of the property ($)",
                  inputType: "number",
                },
                {
                  type: "text",
                  name: "ownership_percent",
                  title: "Your % ownership of the property",
                },
                {
                  type: "boolean",
                  name: "sale_during_fy",
                  title:
                    "Did you dispose of the property during the financial year?",
                },
                {
                  type: "text",
                  name: "sale_price",
                  visibleIf: "{sale_during_fy} = true",
                  title: "Sale price of the property ($)",
                  inputType: "number",
                },
                {
                  type: "text",
                  name: "date_of_sale",
                  visibleIf: "{sale_during_fy} = true",
                  title: "Date of sale",
                  inputType: "date",
                },
                {
                  type: "file",
                  allowMultiple: true,
                  name: "sale_docs",
                  visibleIf: "{sale_during_fy} = true",
                  title:
                    "Upload: Purchase contract, Sale contract and settlement statement(s)",
                  storeDataAsText: false,
                  waitForUpload: true,
                  maxSize: 5000000,
                },
                {
                  type: "file",
                  allowMultiple: true,
                  name: "agent_annual_statement",
                  title:
                    "Upload: Annual statement from property manager (if managed)",
                  storeDataAsText: false,
                  waitForUpload: true,
                  maxSize: 5000000,
                },
              ],
            },
            {
              type: "panel",
              name: "income_details",
              title: "Income",
              elements: [
                {
                  type: "text",
                  name: "rental_income",
                  title: "Rental income (Amount $)",
                },
                {
                  type: "text",
                  name: "other_income",
                  title: "Other related income (Amount $)",
                },
                {
                  type: "text",
                  name: "gross_income",
                  title: "Gross income (Amount $)",
                },
              ],
            },
            {
              type: "panel",
              name: "expense_details",
              title: "Expenses (Financial Year)",
              elements: [
                {
                  type: "text",
                  name: "advertising",
                  title: "Advertising for tenants ($)",
                  inputType: "number",
                },
                {
                  type: "text",
                  name: "bank_charges",
                  title: "Bank charges ($)",
                  inputType: "number",
                },
                {
                  type: "text",
                  name: "body_corporate_fees",
                  title: "Body corporate fees ($)",
                  inputType: "number",
                },
                {
                  type: "text",
                  name: "borrowing_expenses",
                  title: "Borrowing expenses ($)",
                  inputType: "number",
                },
                {
                  type: "text",
                  name: "cleaning",
                  title: "Cleaning ($)",
                  inputType: "number",
                },
                {
                  type: "text",
                  name: "council_rates",
                  title: "Council rates ($)",
                  inputType: "number",
                },
                {
                  type: "text",
                  name: "gardening",
                  title: "Gardening/lawn mowing ($)",
                  inputType: "number",
                },
                {
                  type: "text",
                  name: "insurance",
                  title: "Insurance ($)",
                  inputType: "number",
                },
                {
                  type: "text",
                  name: "interest_loans",
                  title: "Interest on loans ($)",
                  inputType: "number",
                },
                {
                  type: "text",
                  name: "land_tax",
                  title: "Land tax ($)",
                  inputType: "number",
                },
                {
                  type: "text",
                  name: "legal_fees",
                  title: "Legal fees ($)",
                  inputType: "number",
                },
                {
                  type: "text",
                  name: "pest_control",
                  title: "Pest control ($)",
                },
                {
                  type: "text",
                  name: "agent_fees",
                  title: "Property Agent fees/commission ($)",
                },
                {
                  type: "text",
                  name: "stationery_phone",
                  title: "Stationery, phone ($)",
                },
                {
                  type: "text",
                  name: "sundry",
                  title: "Sundry expenses ($)",
                },
                {
                  type: "text",
                  name: "water_charges",
                  title: "Water charges ($)",
                },
                {
                  type: "file",
                  allowMultiple: true,
                  name: "loan_statements",
                  title: "Upload applicable bank statements for loans",
                  storeDataAsText: false,
                  waitForUpload: true,
                  maxSize: 5000000,
                },
                {
                  type: "text",
                  name: "total_expenses",
                  title:
                    "Total Expenses (Amount $) less repairs and maintenance",
                  inputType: "number",
                },
              ],
            },
            {
              type: "paneldynamic",
              name: "repairs_list",
              title: "Repairs and Maintenance List",
              templateElements: [
                {
                  type: "text",
                  name: "repair_date",
                  title: "Date",
                  inputType: "date",
                },
                {
                  type: "text",
                  name: "repair_description",
                  title: "Description",
                },
                {
                  type: "text",
                  name: "repair_amount",
                  title: "Amount $",
                },
              ],
              templateTitle: "Repair {panelIndex}",
              panelCount: 1,
              maxPanelCount: 25,
            },
            {
              type: "paneldynamic",
              name: "new_acquisitions",
              title: "New Acquisitions for Rental Property e.g. whitegoods",
              templateElements: [
                {
                  type: "text",
                  name: "item",
                  title: "Description of New Item (e.g. “oven”)",
                },
                {
                  type: "text",
                  name: "date",
                  title: "Date Purchased",
                  inputType: "date",
                },
                {
                  type: "text",
                  name: "amount",
                  title: "Amount $",
                },
              ],
              templateTitle: "Item {panelIndex}",
              panelCount: 1,
              maxPanelCount: 25,
            },
            {
              type: "file",
              allowMultiple: true,
              name: "tax_depreciation_report",
              title:
                "If a quantity surveyor has prepared a tax depreciation report for this property, please upload it here.",
              storeDataAsText: false,
              waitForUpload: true,
              maxSize: 5000000,
              sourceType: "file-camera",
            },
          ],
        },
      ],
    },
  ],
  calculatedValues: [
    {
      name: "var1",
      expression: "{tfn}",
      includeIntoResult: true,
    },
  ],
  tfns: '[{"name":"tfn", "type": "question"}, {"name": "spouseTfn", "type": "panel", "panel": "question36"}]',
};

// CommonJS, not "export": helper/firmFormRoutes.js requires this file as the
// server schema copy for the firm form route. The view keeps its named import.
module.exports = { mckinleyForm };
